import { useMemo } from 'react';

export const useSelectionBasedRenderKey = (selectedIds: string[]) => {
  /** * @description
   * Indicates to React that this component's internal state must not be preserved
   * when the selection changes.
   *
   * Solves: The nested dimension number inputs were being kept mounted (reused) by react
   * when the active selection changed. This caused a race condition where the `onBlur`
   * handler of entity A fired after the selection already shifted to entity B, applying entity A's stale
   * draft state to the newly selected entity B.
   */
  const renderKey = useMemo(() => selectedIds.join(''), [selectedIds]);

  return { renderKey };
};
